import React from 'react'
import { Navigate } from 'react-router-dom'

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'))
const BookingsPage = React.lazy(() => import('./views/Bookings'))
const AddSubscriber = React.lazy(() => import('./views/AddSubscriber/AddSubscriber'))
const AddBulkSubscriber = React.lazy(() => import('./views/AddSubscriber/AddBulkSubscriber'))
const UserProfile = React.lazy(() => import('./views/UserProfile/UserProfile'))
const HelpDesk = React.lazy(() => import('./views/UserProfile/HelpDesk'))
const OrganizationGoals = React.lazy(() => import('./views/UserProfile/OrganizationGoals'))
const BillingAndPlans = React.lazy(() => import('./views/billingAndPlans/billingPlans'))
const BusinessOnboarding = React.lazy(() => import('./views/onboardng/BusinessOnboarding'))
const MembersTable = React.lazy(() => import('./views/members/index'))
const TherapyPsychiatryBusiness = React.lazy(() =>
  import('./views/TherapyPsychiatryBusiness/index'),
)
const Webinars = React.lazy(() => import('./views/Webinars/WebinarsListing'))
const Wallet = React.lazy(() => import('./views/Wallet/Wallet'))

const routes = [
  // TOP LEVEL SANITY TESTED:

  { index: true, element: Dashboard },

  // NOT WORKING CORRECTLY:
  { path: 'onboarding', name: 'Onboarding', exact: true, element: BusinessOnboarding },
  { path: 'organization-goals', name: 'Organization Goals', element: OrganizationGoals },

  // TOP LEVEL SANITY NOT TESTED:
  {
    path: 'addBulkSubscriber',
    name: 'Add Bulk Subscriber',
    exact: true,
    element: AddBulkSubscriber,
  },
  { path: 'profile', name: 'Profile', exact: true, element: UserProfile },
  { path: 'bookings', name: 'Bookings', exact: true, element: BookingsPage },
  { path: 'wallet', name: 'Wallet & Credits', exact: true, element: Wallet },
  { path: 'HelpDesk', name: 'Help Desk', exact: true, element: HelpDesk },
  { path: 'billingandplans', name: 'Billing and Plans', exact: true, element: BillingAndPlans },

  ///////////////////WEBINARS/////////////////////////

  { path: 'webinars', name: 'Webinars', exact: true, element: Webinars },

  ///////////////////SUBSCRIBERS/////////////////////////

  { path: 'members/add-subscriber', name: 'Add Subscriber', exact: true, element: AddSubscriber },

  { path: 'members', name: 'Members Table', exact: true, element: MembersTable },
  { path: 'one-on-one', name: 'One on One', exact: true, element: TherapyPsychiatryBusiness },
]

export default routes
